module.exports = __webpack_public_path__ + "img/Unio.eef4a466.svg";